import cloneDeep from 'lodash/fp/cloneDeep'
import {
  events
} from './administratorsContainerActions'

const initialState = {
  fetchingAdministrators: false,
  administrators: [],
  submitAdministrator: false,
  submittingAdministrator: false,
  submittedAdministrator: false,
  administratorIndex: -1
}

export default function (state = initialState, action) {
  const { load, setting, submitting, submitted } = events
  var newState = cloneDeep(state)

  switch (action.type) {
    case load.fetching:
      newState.fetchingAdministrators = true
      return newState
    case load.fetched:
      newState.fetchingAdministrators = false
      newState.administrators = action.payload
      return newState
    case setting.toggleAdministratorActive: {
      newState.submittedAdministrator = false
      newState.administratorIndex = action.index
      newState.submitAdministrator = true
      const admin = newState.administrators[action.index]
      admin.isActive = !admin.isActive
      return newState
    }
    case submitting.administrator:
      newState.submitAdministrator = false
      newState.submittingAdministrator = true
      return newState
    case submitted.administrator:
      newState.submittingAdministrator = false
      newState.submittedAdministrator = true
      return newState
    default:
      return state
  }
}
